import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1420px;
	margin: 0 auto;
	color: ${CSSVars.white};
	display: flex;
	justify-content: space-between;
	gap: 20px;
	flex-direction: column-reverse;

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		flex-direction: row;
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		gap: 50px;
	}

	.discover-card {
		width: 100%;
		gap: 10px;
		display: flex;
		flex-direction: column;

		a {
			font-size: ${CSSVars.fontSizeMD};
			font-weight: 300;
			text-decoration: none;
			color: white;
			transition: 0.2s;
			text-transform: capitalize;

			&:hover {
				color: ${CSSVars.primary500};
			}
		}

		p.discover-title {
			font-weight: 600;
			font-size: ${CSSVars.fontSizeLG};

			&:last-of-type {
				margin-top: 20px;
			}
		}

		.search-box {
			width: 100%;
			max-width: 440px;
		}

		form {
			position: relative;
			z-index: 10;
			margin: 0 0 20px;
		}

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			width: 320px;
		}
	}

	.apps-container {
		/* background-color: gray; */
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 30px;
		text-decoration: none;

		.app {
			border-radius: 5px;
			background-color: ${CSSVars.gray600};
			border: 1px solid #2a2e42;
			transition: 0.2s;
			padding: 30px;
			cursor: pointer;
			margin-bottom: 30px;

			display: flex;
			justify-content: space-between;
			gap: 20px;
			color: ${CSSVars.white};
			flex-direction: column;

			@media screen and (min-width: ${CSSVars.breakpointSM}) {
				flex-direction: row;
			}

			.details {
				display: flex;
				gap: 20px;
				flex-direction: column;
				text-align: center;

				@media screen and (min-width: ${CSSVars.breakpointSM}) {
					text-align: left;
					flex-direction: row;
				}

				.logo-wrapper {
					position: relative;
					margin: 0 auto;
					height: fit-content;
					width: fit-content;

					@media screen and (min-width: ${CSSVars.breakpointSM}) {
						margin: 0;
					}

					img {
						border-radius: 5px;
						width: 100px;
						height: 100px;
						min-width: 100px;
						min-height: 100px;
						object-fit: cover;
					}

					.platform {
						object-fit: contain;
						border-radius: 50%;
						position: absolute;
						left: 50%;
						top: 100%;
						transform: translate(-50%, -50%);
						background-color: ${CSSVars.gray600};
						padding: 3px;
						height: 30px;
						width: 30px;
						min-width: 30px;
						min-height: 30px;
					}
				}

				.content {
					h3 {
						font-size: ${CSSVars.fontSizeLG};
						font-weight: 600;

						text-transform: none;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;
						word-break: break-all;
					}

					p.desc {
						word-break: break-all;
						font-size: ${CSSVars.fontSizeMD};
						font-weight: 300;
						max-width: 600px;

						text-transform: none;

						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;
					}

					.tags {
						margin-top: 15px;
						display: flex;
						gap: 10px;
						align-items: center;
						flex-wrap: wrap;
						justify-content: center;

						@media screen and (min-width: ${CSSVars.breakpointSM}) {
							justify-content: flex-start;
						}

						.tag {
							font-size: ${CSSVars.fontSizeXS};
							padding: 5px 12px;
							background-color: ${CSSVars.primary500};
							border-radius: 20px;
							font-weight: 600;
						}
					}
				}
			}

			.rating-wrapper {
				display: flex;
				flex-direction: column;
				gap: 10px;
				align-items: center;

				@media screen and (min-width: ${CSSVars.breakpointSM}) {
					align-items: flex-end;
				}

				.rating {
					color: #ffc657;
				}

				.reviews {
					font-size: ${CSSVars.fontSizeSM};
					font-weight: 300;
				}
			}

			&:hover {
				border: 1px solid ${CSSVars.gray500};
			}
		}

		.ais-Pagination {
			margin: 0 auto 30px;
		}

		.ais-Pagination-list {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			flex-wrap: wrap;

			.ais-Pagination-item {
				margin: 2px 2px;
			}

			.ais-Pagination-item--nextPage,
			.ais-Pagination-item--lastPage,
			.ais-Pagination-item--previousPage,
			.ais-Pagination-item--firstPage {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 20px;
				height: 32px;
				border-radius: 4em;
				border: none;

				> * {
					color: ${CSSVars.white};
					cursor: pointer;
					display: inline-block;
					text-align: center;
					flex: 1;
					font-size: 24px;
					opacity: 0.6;
					transition: 0.2s;
				}

				&:hover {
					> * {
						opacity: 1;
					}
				}
			}

			.ais-Pagination-item--page {
				a {
					color: ${CSSVars.gray500};
					width: 20px;
					height: 32px;
					line-height: 10px;
					border-radius: 4px;
					display: inline-block;
					display: flex;
					justify-content: center;
					align-items: center;
					font-weight: 400;
					padding-top: 2px;
					transition: 0.2s;
					&.ais-Pagination-link--selected {
						color: ${CSSVars.white};
					}

					&:hover {
						color: ${CSSVars.white};
					}
				}
			}
		}
	}
`;
